import {fsPromises, isStaticSite} from "./electron-modules";

interface TransformResponse {
  success: Boolean,
  content: any
}

export const readTransformFile = (path: string): Promise<TransformResponse> => {
  return new Promise(async resolve => {
    const errorResponse = {
      success: false,
      content: 'Error reading camera correction .4x4 file'
    };

    if (!path) {
      resolve(errorResponse);
      return;
    }

    try {
      let data = isStaticSite ?
        await fetch(path).then(res => res.text()) :
        await fsPromises.readFile(path, {encoding: 'utf8'});

      let arr = [];
      let valid = true;
      let rows = data.split("\n");

      rows.forEach(row => {
        row = row.trim();
        if (row.length === 0) {
          return;
        }

        let cols = row.split(" ");
        if (cols.length !== 4) {
          valid = false;
        }

        cols.forEach(col => {
          if (isNaN(col)) {
            valid = false;
          }
          arr.push(parseFloat(col));
        });
      });

      if (arr.length !== 16) {
        valid = false;
      }

      if (valid === false) {
        resolve(errorResponse);
        return;
      }

      const successResponse = {
        success: true,
        content: arr
      };

      resolve(successResponse);
      return;
    } catch {
      resolve(errorResponse);
      return;
    }
  });
};